import { call, put } from 'redux-saga/effects';
import { FabricationContractsService } from '../../../services/FabricationContracts';
import { FabricationProjectsService } from '../../../services/FabricationProjects';
import { loadContractByContractNumberSuccess } from '../fabrication-contracts/actions';
import { IFabricationContract } from '../fabrication-contracts/types';
import { loadProjectsSuccess, loadProjectsFailure } from './actions';
import { IFabricationProjectResponse, IFabricationProject } from './types';

interface IProjectSagaParams {
  payload: {
    project: IFabricationProject;
    contractNumber: string;
    needToLoadContract: boolean;
  };
}

export function* loadProjectsSaga(params: IProjectSagaParams) {
  const { contractNumber, needToLoadContract } = params.payload;

  if (needToLoadContract) {
    try {
      const fabricationContractsService = new FabricationContractsService();
      const contract: IFabricationContract =
        yield fabricationContractsService.getContractDetails(contractNumber);
      yield put(loadContractByContractNumberSuccess(contract));
    } catch (err) {
      yield put(loadProjectsFailure(undefined, true));
      return;
    }
  }

  try {
    const projectsService = new FabricationProjectsService();
    const projectsResponse: IFabricationProjectResponse = yield call(
      projectsService.getFabricationProjects.bind(
        projectsService,
        contractNumber
      )
    );

    yield put(loadProjectsSuccess(projectsResponse));
  } catch (err) {
    yield put(loadProjectsFailure(err));
  }
}
